export const FONT_FAMILY = {
  heading: `"Aboreto", system-ui`,
  fantasy: `"Aboreto", system-ui`,
  body: ` "Newsreader", serif`,
};
